/* ============================================
   TESTIMONIALS CAROUSEL FUNCTIONALITY
   ============================================ */

(function() {
    'use strict';

    const testimonialsCarousels = document.querySelectorAll('[data-testimonials-carousel]');
    if (testimonialsCarousels.length === 0) return;

    // Initialize each testimonials carousel
    testimonialsCarousels.forEach((testimonialsCarousel) => {
        const carousel = testimonialsCarousel.querySelector('.testimonials-carousel__carousel');
        const track = testimonialsCarousel.querySelector('.testimonials-carousel__track');
        const items = testimonialsCarousel.querySelectorAll('.testimonials-carousel__item');
        const prevButton = testimonialsCarousel.querySelector('.testimonials-carousel__arrow--prev');
        const nextButton = testimonialsCarousel.querySelector('.testimonials-carousel__arrow--next');
        const progressLine = testimonialsCarousel.querySelector('.testimonials-carousel__progress-line');

        if (!carousel || !track || items.length === 0) return;

        initCarousel(testimonialsCarousel, carousel, track, items, prevButton, nextButton, progressLine);
    });

    function initCarousel(testimonialsCarousel, carousel, track, items, prevButton, nextButton, progressLine) {
        let currentIndex = 0;
        let itemsPerView = 1; // Mobile: 1 item
        let totalSlides = 0;
        let maxIndex = 0;
        let touchStartX = 0;
        let touchEndX = 0;

        // Update items per view based on screen size
        function updateItemsPerView() {
            if (window.innerWidth >= 992) {
                itemsPerView = 4; // Desktop: 4 items
            } else if (window.innerWidth >= 768) {
                itemsPerView = 2; // Tablet: 2 items
            } else {
                itemsPerView = 1; // Mobile: 1 item
            }

            const totalItems = items.length;
            totalSlides = Math.ceil(totalItems / itemsPerView);
            maxIndex = Math.max(0, totalSlides - 1);
        }

        // Update carousel position
        function updateCarousel() {
            if (items.length <= itemsPerView) {
                track.style.transform = 'translateX(0)';
                return;
            }

            const carouselWidth = carousel.offsetWidth;
            const translateX = -(currentIndex * carouselWidth);

            track.style.transform = `translateX(${translateX}px)`;
        }

        // Update progress bar
        function updateProgress() {
            if (totalSlides === 0) return;

            const progress = ((currentIndex + 1) / totalSlides) * 100;
            if (progressLine) {
                progressLine.style.width = `${progress}%`;
            }
        }

        // Navigate carousel
        function navigateCarousel(direction) {
            const newIndex = currentIndex + direction;

            if (newIndex < 0) {
                currentIndex = 0;
            } else if (newIndex > maxIndex) {
                currentIndex = maxIndex;
            } else {
                currentIndex = newIndex;
            }

            updateCarousel();
            updateProgress();
            updateButtons();
        }

        // Update button states
        function updateButtons() {
            if (prevButton) {
                prevButton.disabled = currentIndex === 0;
            }

            if (nextButton) {
                nextButton.disabled = currentIndex >= maxIndex || items.length <= itemsPerView;
            }
        }

        // Touch/swipe handlers
        function handleTouchStart(e) {
            touchStartX = e.changedTouches[0].screenX;
        }

        function handleTouchEnd(e) {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
        }

        function handleSwipe() {
            const swipeThreshold = 50; // Minimum distance for a swipe
            const diff = touchStartX - touchEndX;

            if (Math.abs(diff) > swipeThreshold) {
                if (diff > 0) {
                    // Swipe left - next slide
                    navigateCarousel(1);
                } else {
                    // Swipe right - previous slide
                    navigateCarousel(-1);
                }
            }
        }

        // Initialize this carousel
        updateItemsPerView();
        updateCarousel();
        updateProgress();
        updateButtons();

        // Set up event listeners
        if (prevButton) {
            prevButton.addEventListener('click', () => navigateCarousel(-1));
        }

        if (nextButton) {
            nextButton.addEventListener('click', () => navigateCarousel(1));
        }

        // Touch/swipe support
        carousel.addEventListener('touchstart', handleTouchStart, { passive: true });
        carousel.addEventListener('touchend', handleTouchEnd, { passive: true });

        // Handle window resize
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                updateItemsPerView();
                currentIndex = 0; // Reset to first slide on resize
                updateCarousel();
                updateProgress();
                updateButtons();
            }, 250);
        });
    }
})();
